// @flow
import * as React from 'react';
import { Item, List } from './styles';

type Props = {
    children: Array<React$Element<any>>
};

const NumberedList = ({ children }: Props) => (
    <List>{React.Children.map(children, item => <Item key={item.key}>{item}</Item>)}</List>
);

export default NumberedList;



// WEBPACK FOOTER //
// ./src/components/widgets/numbered-list/index.js